<template>
  <div class="app-tip">
    <div class="close" @click="close">
      <Icon :size="19">tubiaoguifan2</Icon>
    </div>
    <div class="logo">
      <!-- <svg class="svg-icon" aria-hidden="true">
        <use xlink:href="#icon-LOGO"></use>
      </svg> -->
      <img class="logo_img" :src="imgLogo" />
      <!-- <Icon :size="37">LOGO</Icon> -->
    </div>
    <div class="text">
      <div class="title">苏打爱生活</div>
      <div class="subTitle">轻管理，享福利</div>
    </div>
    <div class="open" @click="openApp">打开APP</div>
  </div>
</template>

<script>
import Icon from './icon'
import imgLogo from '@img/common/logo_small.png'


  import('../../stylesheet/iconfont/iconfont')

  const appLink = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.sdyx.mall'

  const openInIframe = (url) => {
    const iframe = document.createElement('iframe')
    iframe.style.cssText = 'display:none;width=0;height:0'
    document.body.appendChild(iframe)
    iframe.open = url
    setTimeout(function() {
      document.body.removeChild(iframe)
    }, 500)
  }

  export default {
    data() {
      return {
        data: '',
        imgLogo
      }
    },
    methods: {
      close () {
        this.$store.dispatch('disableAppTip')
      },
      openApp () {
        let url = ''
        const src = this.$store.state.rc.app.src
        let action = this.$store.state.rc.app.action
        // hardcode to download link
        return window.location.href = appLink
        // src来源为商品详情页且当前页面为商品详情页 则跳转商品详情页。
        // const productId = this.$route.name === 'itemDetail' && this.$route.params.id
        // if (src == 1 && !!productId) {
        //   let appact = {
        //     actionType: 7,
        //     actionData: `{"businessId": ${productId}}`
        //   }
        //   action = JSON.stringify(appact)
        // }
        // // hardcode app action location in wechat
        // if (app.isWechat() && os.isIOS()) {
        //   url = resolveAppLinkPath(action)
        // } else if (app.isWechat() && os.isAndroid()) {
        //   return window.location.href = appLink
        // } else {
        //   url = resolveAppSchemePath(action)
        // }
        // return setTimeout(function() {
        //   openInIframe(url)
        // }, 0)
        // window.location.href = url
      },
    },
    components: {
      Icon,
    },
    mounted() {
      // this.$store.
    }
  }
</script>
<style lang="less" scoped>
  .app-tip {
    height: 49px;
    width: 100%;
    position: fixed;
    top: 0;
    background: rgba(25, 26, 27, 0.9);
    color: #fff;
    z-index: 10;
    .close {
      float: left;
      font-size: 20px;
      line-height: 50px;
      text-align: center;
      width: 50px;
      height: 50px;
    }
    .logo {
      float: left;
      font-size: 35px;
      line-height: 35px;
      text-align: center;
      width: 35px;
      height: 35px;
      border-radius: 18px;
      margin-top: 7px;
      .logo_img{
        width:34px;
        border-radius:8px;
      }
      .svg-icon {
        width: 1em; height: 1em;
        fill: currentColor;
        overflow: hidden;
      }
    }
    .text {
      float: left;
      padding: 6px 0 6px 10px;
      .title {
        font-size: 13px;
      }
      .subTitle {
        font-size: 12px;
      }
    }
    .open {
      float: right;
      background: rgb(192, 49, 49);
      width: 70px;
      height: 27px;
      border-radius: 2px;
      margin: 11px 15px 11px 0;
      text-align: center;
      line-height: 27px;
    }
  }
</style>
